import React from 'react'
import { XStack, YStack } from 'tamagui'

import { Card } from '@newComponents/Card'
import { Icon } from '@newComponents/Icon'
import { Paragraph } from '@newComponents/Text'
import { Link } from '@newComponents/Link'

import { DocSection } from '../shared/DocSection'
import { DocScreenshot } from '../shared/DocScreenshot'

const Page = () => (
  <>
    <Card gap='$4'>
      <Paragraph size='$5'>
        Every Presentation has its own page that showcases the talk and
        connects it back to the Events and Guilds where it was delivered.
      </Paragraph>
      <DocScreenshot
        src='docs/presentations/presentation-page.png'
        alt='Presentation page for Navigating the Seven C&#39;s by Taz Singh showing presenter photo and name, Presentation by attribution, description text, and Presented at these Events section with linked Event cards'
        caption='A Presentation page with presenter info, description, and linked Events'
      />
    </Card>

    <Card gap='$4'>
      <DocSection id='page-layout' title='Page Layout'>
        <Paragraph size='$5'>
          The page opens with the presenter's photo and the Presentation title.
          Below the title, a{' '}
          <Paragraph size='$5' fontWeight='$7'>Presentation by</Paragraph>{' '}
          label sits above the presenter's name, which links to their profile.
          If a video URL has been added, a YouTube or Vimeo player appears at
          the top of the page so visitors can watch the recording.
        </Paragraph>
        <Paragraph size='$5'>
          Owners and Organizers see a{' '}
          <Paragraph size='$5' fontWeight='$7'>Settings</Paragraph> button on
          the Presentation page, providing quick access to edit the title,
          description, video, or presenter details.
        </Paragraph>
        <Paragraph size='$5'>
          The description section provides context about the talk — what was
          covered, key takeaways, or any resources the presenter wants to
          share.
        </Paragraph>
      </DocSection>
    </Card>

    <Card gap='$4'>
      <DocSection id='related-sections' title='Related Sections'>
        <YStack gap='$3'>
          <XStack gap='$3' alignItems='flex-start'>
            <Icon name='calendar' size='$5' color='$color' flexShrink={0} marginTop={2} />
            <Paragraph size='$5'>
              <Paragraph size='$5' fontWeight='$7'>Presented at these Events</Paragraph>{' '}
              — Lists every{' '}
              <Link href='/docs/events/overview'>Event</Link> the Presentation has been
              linked to, with clickable Event cards that make it easy for viewers
              to discover where the talk was given and explore related Events.
            </Paragraph>
          </XStack>
          <XStack gap='$3' alignItems='flex-start'>
            <Icon name='people' size='$5' color='$color' flexShrink={0} marginTop={2} />
            <Paragraph size='$5'>
              <Paragraph size='$5' fontWeight='$7'>Presented with these Guilds</Paragraph>{' '}
              — Shows the{' '}
              <Link href='/docs/guilds/overview'>Guilds</Link> affiliated with the
              Presentation, connecting the talk back to the communities that
              hosted it.
            </Paragraph>
          </XStack>
          <XStack gap='$3' alignItems='flex-start'>
            <Icon name='projection-screen' size='$5' color='$color' flexShrink={0} marginTop={2} />
            <Paragraph size='$5'>
              <Paragraph size='$5' fontWeight='$7'>Similar Presentations</Paragraph>{' '}
              — Surfaces related talks from across Guild, helping viewers discover
              more content on topics they care about.
            </Paragraph>
          </XStack>
        </YStack>
      </DocSection>
    </Card>
  </>
)

export default Page
